import { BookOpen, Coins, Landmark, Receipt } from 'lucide-react';
import Bancos from '../finanzas/Bancos';
import CuentasPorPagar from '../finanzas/CuentasPorPagar';
import Polizas from '../finanzas/Polizas';
import TuDinero from '../finanzas/TuDinero';

/* =====================================================================
   Las pantallas del carril `erp-finanzas` · ERP-OPERATIVO EF1–EF5
   =====================================================================
   Un grupo propio, «Finanzas», al final del menú. Cada pantalla se
   enseña por su llave (permisos como datos, 400/407/413/421); el tablero
   es del dueño y va por rango.
   ===================================================================== */
export default {
  orden: 50,
  grupos: [{
    grupo: 'Finanzas',
    items: [
      { id: 'finanzas-tu-dinero', etiqueta: 'Caja y bancos hoy', icono: Coins, min: 'DUENO', Comp: TuDinero },
      { id: 'finanzas-cuentas-por-pagar', etiqueta: 'Cuentas por pagar', icono: Receipt, permiso: 'cxp.ver', min: 'ENCARGADO', Comp: CuentasPorPagar },
      { id: 'finanzas-bancos', etiqueta: 'Bancos', icono: Landmark, permiso: 'bancos.ver', min: 'ADMIN', Comp: Bancos },
      { id: 'finanzas-polizas', etiqueta: 'Pólizas', icono: BookOpen, permiso: 'polizas.ver', min: 'ADMIN', Comp: Polizas },
    ],
  }],
};
